<template>
  <el-dialog
    ref="dialog"
    v-dialogDrag
    :title="dialogTitle"
    :visible.sync="dialogVisible"
    class="data_list_dialog"
    width="1200px"
    :before-close="modalClose"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    append-to-body
    @open="handleOpen('dialog')"
  >
    <div
      v-loading="loading"
      :loading="loading"
      :element-loading-text="loadingText"
      element-loading-spinner="el-icon-loading"
      element-loading-background="rgba(0, 0, 0, 0.8)"
    >
      <div class="container-box">
        <el-row :gutter="10">
          <el-col
            :span="24"
            style="text-align:right;padding-right:6px"
          >
            <el-button
              type="primary"
              @click="ExportByPage()"
            >
              导出
            </el-button>
          </el-col>
        </el-row>
        <!-- 数据列表 -->
        <div class="table-wrap table-list-show">
          <view-table
            :table-columns="tableColumns"
            :table-data="tableData"
          />
        </div>
      </div>
    </div>
  </el-dialog>
</template>
<script>
// 自定义Table
import ViewTable from '@/components/viewTable'
// 计算表格高度，搜索，获取数据Mixin
import dialogTableCustomMixin from '@/mixin/dialogTableCustomMixin'
// dialog 拖拽dialogDragMixin
import dialogDragMixin from '@/mixin/dialogDragMixin'
// 数据请求
import { findOutdepotBillDetailListDataByStatisticsItemApi, exportOutdepotBillDetailListDataByStatisticsItemApi } from '@/api/outdepotBill'
export default {
  name: 'MaterialList',
  components: { ViewTable },
  mixins: [dialogDragMixin, dialogTableCustomMixin],
  props: {
    dialogTitle: {
      type: String,
      default: ''
    },
    dialogVisible: {
      type: Boolean,
      default: false
    },
    themeColor: {
      type: String,
      default: ''
    },
    selectItem: {
      type: Object,
      default: null
    },
    viewType: {
      type: Number,
      default: 1
    }
  },
  data () {
    return {
      loading: false,
      loadingText: '努力加载数据中，请耐心等待',
      tableColumns: [],
      tableData: []
    }
  },
  watch: {
    dialogVisible (val) {
      if (val) {
        this.loading = true
        this.tableData = []
        if(this.viewType === 1){ // 日常工作出库
          this.tableColumns = [
            { prop: 'outdepotTypeStr', label: '出库类型', width: 120},
            { prop: 'operater', label: '经办人', width: 120},
            { prop: 'receiver', label: '物料领用人', width: 120},
            { prop: 'materialsName', label: '物料名称' },
            { prop: 'outAmount', label: '数量', width: 120 },
            { prop: 'remark', label: '备注', width: 180 }
          ]
        } else if (this.viewType === 2 || this.viewType === 3 || this.viewType === 6) { // 渠道营销或其它出库或退分中心出库
          this.tableColumns = [
            { prop: 'depotName', label: '出库库房', width: 120},
            { prop: 'operateDate', label: '出库时间', width: 120 },
            { prop: 'typeStr', label: '出库类型', width: 120 },
            { prop: 'operater', label: '经办人', width: 140 },
            { prop: 'receiver', label: '物料领用人', width: 140 },
            { prop: 'materialsName', label: '物料名称' },
            { prop: 'amount', label: '数量', width: 120 },
            { prop: 'remark', label: '备注', width: 180 }
          ]
        } else if (this.viewType === 5) { //核销明细
          this.tableColumns = [
            { prop: 'usedName', label: '店名', width: 160 },
            { prop: 'materialsName', label: '物料名称' },
            { prop: 'amount', label: '数量', width: 120 },
            { prop: 'usedMethod', label: '用途', width: 120 },
            { prop: 'executorName', label: '发放人', width: 120 },
            { prop: 'usedDateStr', label: '发放时间', width: 120},
            { prop: 'remark', label: '备注', width: 180 }
          ]
        } else if (this.viewType === 4){ // 未核销数量
            this.tableColumns = [
            { prop: 'materialsName', label: '物料名称', width: 410},
            { prop: 'receiver', label: '物料使用人'},
            { prop: 'amount', label: '领用数量' },
            { prop: 'usedAmount', label: '使用数量' },
            { prop: 'backAmount', label: '退回数量' },
            { prop: 'leftAmount', label: '剩余数量' }
          ]
        }
        this.searchData()
      }
    }
  },
  methods: {
    // 查询
    searchData () {
      let params = {
        schemeId: this.selectItem.schemeId,
        materialsId: this.selectItem.materialsId
      }
      if (this.viewType === 1) {
        params.type = 1
      } else if (this.viewType === 2 || this.viewType === 3 || this.viewType === 6) {
        params.type = 2
        if (this.viewType === 2) {
          params.outdepotType = 5
        } else if (this.viewType === 3){
          params.outdepotType = 2
        } else if (this.viewType === 6){
          params.outdepotType = 7
        }
      } else if (this.viewType === 4){
        params.type = 3
      } else {
        params.type = 4
        params.status = 3
        params.pageOrder = 'db.used_date desc'
      }
      findOutdepotBillDetailListDataByStatisticsItemApi(params).then(response => {
        this.tableData = response.data ? response.data : []
        this.loading = false
      })
    },
    // 关闭弹框
    modalClose () {
      this.$emit('update:dialogVisible', false) // 直接修改父组件的属性
    },
    // 导出数据API
    ExportByPage () {
      let excelNames = ''
      let excelKeys = ''
      let params = {
        schemeId: this.selectItem.schemeId,
        materialsId: this.selectItem.materialsId
      }
      if (this.viewType === 1) {
        params.type = 1
        excelNames = '出库类型,经办人,物料领用人,物料名称,数量,备注'
        excelKeys = 'outdepotTypeStr,operater,receiver,materialsName,outAmount,remark'
      } else if (this.viewType === 2 || this.viewType === 3 || this.viewType === 6) {
        params.type = 2
        excelNames = '出库库房,出库时间,出库类型,经办人,物料领用人,物料名称,数量,备注'
        excelKeys = 'depotName,operateDate,typeStr,operater,receiver,materialsName,amount,remark'
        if (this.viewType === 2) {
          params.outdepotType = 5
        } else if (this.viewType === 3){
          params.outdepotType = 2
        } else if (this.viewType === 6){
          params.outdepotType = 7
        }
      } else if (this.viewType === 4){
        params.type = 3
        excelNames = '物料名称,物料使用人,领用数量,使用数量,退回数量,剩余数量'
        excelKeys = 'materialsName,receiver,amount,usedAmount,backAmount,leftAmount'
      } else {
        params.type = 4
        excelNames = '店名,物料名称,数量,用途,发放人,发放时间,备注'
        excelKeys = 'usedName,materialsName,amount,usedMethod,executorName,usedDateStr,remark'
        params.status = 3
        params.pageOrder = 'db.used_date desc'
      }
      params.excelNames = excelNames
      params.excelKeys = excelKeys
      exportOutdepotBillDetailListDataByStatisticsItemApi(params).then(res => {
        let exportObj = { exportSuccess: true, url: res.data }
        this.$store.dispatch('message/settingExportSuccess', exportObj)
      })    
    }
  }
}
</script>
<style lang="scss"  scoped>
.table-wrap {
  margin-top: 5px;
}
</style>
/>